import { useState, useRef } from "react";
import UploadUtilityFileSample from '../../../../../images/UploadUtilityFileSample.xlsx'
import { UploadLoanUtilityfilesApi } from "../../AdminActionCreator.component";
import Loader from '../../../../presentationals/Loader/Loader.component'

export default function UploadUtility({ admin }) {
    const [loader, setLoader] = useState(false)
    const [uploadedFile, setUploadedFile] = useState(null);
    const [previewSrc, setPreviewSrc] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    const [status, setStatus] = useState(null);
    const fileInputRef = useRef(null);

    const handleFile = (file) => {
        if (!file) return;
        setUploadedFile(file);
        setStatus(null);
        if (file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = (e) => setPreviewSrc(e.target.result);
            reader.readAsDataURL(file);
        } else {
            setPreviewSrc(null);
        }
    };

    const clearFile = () => {
        setUploadedFile(null);
        setPreviewSrc(null);
        setStatus(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const uploadFile = () => {
        if (!uploadedFile) return;
        setStatus({ msg: `Uploading ${uploadedFile.name}…`, bg: "#dbeafe", color: "#1d4ed8" });
        console.log("uploadedFile", uploadedFile)
        setLoader(true)
        UploadLoanUtilityfilesApi(uploadedFile, callback => {
            setLoader(false)
            if (callback?.status == 200) {
                setStatus({ msg: `✓ ${uploadedFile.name} uploaded successfully!`, bg: "#dcfce7", color: "#15803d" });
            } else {
                setStatus({ msg: `Error uploading File!`, bg: "#fcdce6", color: "#801515" });
            }
            setUploadedFile(null);
            setPreviewSrc(null);
            if (fileInputRef.current) fileInputRef.current.value = "";
            setTimeout(() => setStatus(null), 5000);
        })
    };


    const downloadSample = () => {
        setLoader(true)
        const a = document.createElement("a");
        a.href = UploadUtilityFileSample;
        a.download = "UploadUtilitySampleFile.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setStatus({ msg: "Sample file downloaded!", bg: "#fef9c3", color: "#854d0e" });
        setLoader(false)
        setTimeout(() => setStatus(null), 3000);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => setIsDragging(false);

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const file = e.dataTransfer.files[0];
        if (file) handleFile(file);
    };

    return (
        <div style={{ background: "#fff", fontFamily: "sans-serif" }}>
            {loader ? <Loader /> : " "}




            {/* Tab Content */}
            <div style={{ padding: "40px 28px" }}>

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 240, borderRadius: 14, padding: 32 }}>
                    <div style={{ width: "100%", maxWidth: 540 }}>

                        {/* Drop zone */}
                        <div
                            onClick={() => fileInputRef.current?.click()}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            style={{
                                border: `2px dashed ${isDragging ? "#1d4ed8" : "#3b82f6"}`,
                                borderRadius: 12,
                                background: isDragging ? "#eff6ff" : "#dbeafe",
                                padding: "38px 24px",
                                textAlign: "center",
                                cursor: "pointer",
                                transition: "all 0.2s",
                            }}
                        >
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" style={{ display: "inline-block", marginBottom: 8 }}>
                                <path d="M12 16V8M12 8L9 11M12 8L15 11" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M20.39 18.39A5 5 0 0018 9h-1.26A8 8 0 103 16.3" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <p style={{ margin: 0, fontSize: 15, fontWeight: 600, color: "#2563eb" }}>
                                {uploadedFile ? "File selected — click to change" : "Click here to Upload Logo"}
                            </p>
                            <p style={{ margin: "5px 0 0", fontSize: 12, color: "#60a5fa" }}>or drag and drop your file here</p>
                            <input
                                ref={fileInputRef}
                                type="file"
                                accept=".xlx,.csv,.xlsx,"
                                style={{ display: "none" }}
                                onChange={(e) => handleFile(e.target.files[0])}
                            />
                        </div>

                        {/* File preview */}
                        {uploadedFile && (
                            <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 14, background: "#fff", border: "0.5px solid #e5e7eb", borderRadius: 12, padding: "14px 16px" }}>
                                {previewSrc ? (
                                    <img src={previewSrc} alt="preview" style={{ width: 52, height: 52, objectFit: "contain", borderRadius: 6, border: "0.5px solid #e5e7eb" }} />
                                ) : (
                                    <div style={{ width: 52, height: 52, borderRadius: 6, background: "#dbeafe", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" >
                                            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" />
                                            <polyline points="14 2 14 8 20 8" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                )}
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <p style={{ margin: 0, fontSize: 14, fontWeight: 500, color: "#111", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                        {uploadedFile.name}
                                    </p>
                                    <p style={{ margin: "2px 0 0", fontSize: 12, color: "#6b7280" }}>
                                        {(uploadedFile.size / 1024).toFixed(1)} KB
                                    </p>
                                </div>
                                <button onClick={clearFile} style={{ background: "none", border: "none", cursor: "pointer", padding: 4, color: "#9ca3af" }}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                        <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </button>
                            </div>
                        )}

                        {/* Action buttons */}
                        <div style={{ display: "flex", gap: 12, marginTop: 16 }}>
                            <button
                                onClick={uploadFile}
                                disabled={!uploadedFile}
                                style={{
                                    flex: 1, padding: "11px 0", borderRadius: 8, border: "none",
                                    background: "#2563eb", color: "#fff", fontSize: 14, fontWeight: 500,
                                    cursor: uploadedFile ? "pointer" : "not-allowed",
                                    display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                                    opacity: uploadedFile ? 1 : 0.45, transition: "opacity 0.2s",
                                }}
                            >
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" style={{ width: 'auto' }}>
                                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                                    <polyline points="17 8 12 3 7 8" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <line x1="12" y1="3" x2="12" y2="15" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                                Upload File
                            </button>

                            <button
                                onClick={downloadSample}
                                style={{
                                    flex: 1, padding: "11px 0", borderRadius: 8,
                                    border: "1.5px solid #2563eb", background: "transparent",
                                    color: "#2563eb", fontSize: 14, fontWeight: 500, cursor: "pointer",
                                    display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                                    transition: "background 0.15s",
                                }}
                                onMouseOver={(e) => (e.currentTarget.style.background = "#eff6ff")}
                                onMouseOut={(e) => (e.currentTarget.style.background = "transparent")}
                            >
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" style={{ width: 'auto' }}>
                                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" />
                                    <polyline points="7 10 12 15 17 10" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <line x1="12" y1="15" x2="12" y2="3" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                                Download Sample
                            </button>
                        </div>

                        {/* Status message */}
                        {status && (
                            <div style={{ marginTop: 12, padding: "10px 14px", borderRadius: 8, fontSize: 13, fontWeight: 500, textAlign: "center", background: status.bg, color: status.color }}>
                                {status.msg}
                            </div>
                        )}

                    </div>
                </div>

            </div>
        </div>
    );
}